import { useEffect, useMemo, useState } from 'react';

import { Heading, Panel } from '@savgroup-front-common/core';

import CommandeCardList from '../components/CommandeCardList';
import CommandeTableView from '../components/CommandeTableView';
import { useMobileGlobalSearch } from '../context/MobileGlobalSearchContext';
import type { CommandeRow } from '../types/commande.types';
import {
  filterCommandesBySearchQuery,
  sortCommandesByPurchaseDate,
} from '../utils/commandeSearch';
import { $Page, $PanelInner, COMMANDE_RESPONSIVE_MAX_WIDTH_PX } from './CommandePage.styles';

const MOCK_COMMANDES: CommandeRow[] = [
  {
    numeroCommande: 'CMD-2024-001',
    numeroTracking: '1Z999AA10123456784',
    dateAchat: '2024-03-12',
    nombreProduits: 2,
    clientPrenom: 'Marie',
    clientNom: 'Dupont',
  },
  {
    numeroCommande: 'CMD-2024-002',
    numeroTracking: '6A987654321FR',
    dateAchat: '2024-03-18',
    nombreProduits: 1,
    clientPrenom: 'Thomas',
    clientNom: 'Bernard',
  },
  {
    numeroCommande: 'CMD-2024-003',
    numeroTracking: '3S123456789012345',
    dateAchat: '2024-04-02',
    nombreProduits: 4,
    clientPrenom: 'Sophie',
    clientNom: 'Martin',
  },
  {
    numeroCommande: 'CMD-2024-004',
    numeroTracking: '8Q555666777FR',
    dateAchat: '2024-04-15',
    nombreProduits: 3,
    clientPrenom: 'Julie',
    clientNom: 'Leroy',
  },
  {
    numeroCommande: 'CMD-2024-005',
    numeroTracking: '2B111222333FR',
    dateAchat: '2024-05-08',
    nombreProduits: 1,
    clientPrenom: 'Pierre',
    clientNom: 'Petit',
  },
];

const CommandePage = () => {
  const { searchQuery } = useMobileGlobalSearch();
  const [isNarrowViewport, setIsNarrowViewport] = useState(() =>
    typeof window !== 'undefined'
      ? window.matchMedia(`(max-width: ${COMMANDE_RESPONSIVE_MAX_WIDTH_PX}px)`).matches
      : false,
  );

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    const mediaQuery = window.matchMedia(`(max-width: ${COMMANDE_RESPONSIVE_MAX_WIDTH_PX}px)`);
    const onChange = () => {
      setIsNarrowViewport(mediaQuery.matches);
    };

    onChange();
    mediaQuery.addEventListener('change', onChange);

    return () => mediaQuery.removeEventListener('change', onChange);
  }, []);

  const commandes = useMemo(() => {
    const sortedCommandes = sortCommandesByPurchaseDate(MOCK_COMMANDES);

    if (!isNarrowViewport) {
      return sortedCommandes;
    }

    return filterCommandesBySearchQuery(sortedCommandes, searchQuery);
  }, [isNarrowViewport, searchQuery]);

  return (
    <$Page>
      <Panel>
        <$PanelInner>
          <Heading level={2}>Commandes</Heading>
          {isNarrowViewport ? (
            <CommandeCardList commandes={commandes} searchQuery={searchQuery} />
          ) : (
            <CommandeTableView commandes={commandes} />
          )}
        </$PanelInner>
      </Panel>
    </$Page>
  );
};

export default CommandePage;
